<div class="surface-card p-4 shadow-2 border-round">

    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
        <div class="flex justify-start md:justify-start">
            <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">MAGAZZINI</span>

        </div>
        <div class="flex justify-end md:justify-center">
        </div>

        <div class="flex justify-end md:justify-end">

            <div  class="form_row_item" *ngIf="lockAzienda == null">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsAzienda' [(ngModel)]="filterAzienda" placeholder="impresa" (onChange)="updateFiltered()"></p-dropdown>
            </div>
            &nbsp;

            <div>
              <span class="p-input-icon-left mr-2">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Cerca" [(ngModel)]="textfilter" (input)="filterFullText()" [disabled]="!dataReady"/>
              </span>
            </div>

            <button pButton type="button" icon="pi pi-plus" pTooltip="Crea nuovo magazzino" tooltipPosition="top"
                    class="font-['Poppins']"
                    style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;" label="Nuovo"
                    [disabled]="!dataReady"
                    (click)="openItemEditCreateDialog()"
            >
            </button>
        </div>

    </div>

    <div fxFlex="95%">

        <p-table #comuniDT styleClass="p-datatable-sm" [value]="filteredMagazzini" dataKey="id"
                 [selectionPageOnly]="true" [rowHover]="true" [rows]="30" [showCurrentPageReport]="true"
                 [rowsPerPageOptions]="[30,50,100]" [loading]="!dataReady" responsiveLayout="stack" [paginator]="true"
                 currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                 [globalFilterFields]="['codice','azienda.ragioneSociale', 'tipo']" [sortField]="'codice'" [sortOrder]="1">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="codice">
                        <div class="flex justify-content-between align-items-center">
                            Codice
                            <p-sortIcon field="codice"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="azienda.ragioneSociale">
                        <div class="flex justify-content-between align-items-center">
                            Impresa
                            <p-sortIcon field="azienda.ragioneSociale"></p-sortIcon>
                        </div>
                    </th>
                    <th>
                        <div class="flex justify-content-between align-items-center">
                            Regioni di competenza
                        </div>
                    </th>
                    <th>
                        <div class="flex justify-content-between align-items-center">
                            Azioni
                        </div>
                    </th>

                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>

                    <td><span class="text-lowercase">{{ row.codice }}</span></td>
                    <td><span class="text-lowercase">{{ row.azienda.ragioneSociale }}</span></td>
                    <td>
                        <div class="text-lowercase" *ngFor="let regione of row.regioni">
                            {{ regione.denominazione }}</div>
                    </td>
                    <td>
                        <button pButton type="button" style="color:rgb(44, 113, 144);" class="p-button-rounded p-button-text"
                                tooltipPosition="top" pTooltip="Stato scorte"
                                (click)="openPageScorte(row)">
                                    <i class="material-symbols-outlined mr-2"> shelves </i>

                        </button>

                        <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-pencil" class="p-button-rounded p-button-text"
                                tooltipPosition="top" pTooltip="Modifica Magazzino"
                                (click)="openItemEditCreateDialog(row)">
                        </button>

<!--                        <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-text" (click)="openItemDeleteDialog(row)" style="color:red;" tooltipPosition="top" pTooltip="Elimina Magazzino">
                        </button>-->
                    </td>
                    <!--           <td> <span class="text-lowercase">{{row.regione.denominazione}}</span>
                     -->


                </tr>
            </ng-template>

        </p-table>

    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"></p-confirmDialog>

<p-toast position="top-center"></p-toast>
